import { State } from '@shared-store/app.store';

export function selectSystemError(state: State) { return state.shared.systemError; }
